module.exports = __webpack_public_path__ + "static/media/noperformancechart.c82a67b5.png";